import { SPACING } from '@/lib/styles'
import { cn } from '@/lib/utils'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
  maxWidth?: 'full' | 'container' | 'narrow'
}

export function PageContainer({
  children,
  className,
  maxWidth = 'full',
}: PageContainerProps) {
  return (
    <div
      className={cn(
        'h-full flex flex-col',
        SPACING.page,
        maxWidth === 'container' && 'max-w-4xl mx-auto',
        maxWidth === 'narrow' && 'max-w-2xl mx-auto',
        className
      )}
    >
      {children}
    </div>
  )
}

